import { useAuth } from "../context/AuthContext";

export function usePermissions() {
  const { user } = useAuth();

  const canManageBankAccounts =
    user?.role === "admin" ||
    user?.companyPolicy?.can_manage_bank_accounts === true;

  return {
    canManageBankAccounts,
  };
}